<template lang="pug">
  container.mt-30.mb-60.md-mt-50.md-mb-90(:width="row.width")
    carousel.md-pb-flx-carousel(:images="row.images", :class="{'pb-ar-sqr bg-gray-200 md-bg-transp': multipleImgs}")
</template>

<script>
import Container from '@/components/Container'
import Carousel from '@/components/Carousel/Carousel'
export default {
  name: 'Flx__Carousel',
  props: ['row', 'index'],
  computed: {
    multipleImgs () {
      return this.row.images.length > 1
    }
  },
  components: { Container, Carousel }
}
</script>

<style>
</style>
